import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderInput } from '@/models/homeService';

export const createHomeServiceOrders = async (data: HomeServiceOrderInput[]) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation CreateHomeServiceOrders($data: [HomeServiceOrderInputType!]!) {
        createHomeServiceOrders(data: $data) {
          id
        }
      }
    `),
  });

  return response.data?.createHomeServiceOrders ?? [];
};
